export const apiHost = process.env.NEXT_PUBLIC_API_HOST ?? 'https://union-staging.barstoolsports.com/v2'